/**
 * Query-параметр `userCardTab` управляет тем, на какой вкладке открыть карточку
 * собеседника на странице чатов сразу после загрузки. Допустимые значения — это
 * значения `EUserCardTab` (например, `userCardTab=clientInfo`).
 * Пример диплинка: `/dialogs/?chatId=<id>&userCardTab=clientInfo`.
 */
export const USER_CARD_TAB_QUERY_PARAM = 'userCardTab';
